import { Timeline, TimelineItem, TimelineOppositeContent, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent } from "@mui/lab"
import { StoricoCondizioneBeneContratto } from "../../models/StoricoCondizioneBeneContrattoModel"
import { displayFormattedWithTime } from "../../utils/date"

interface BeneStateHistoryProps {
  history: StoricoCondizioneBeneContratto[]
}

const BeneStateHistory: React.FC<BeneStateHistoryProps> = ({ history }) => {

  const titleFontSize = "15px"

  return (
    <>
      <Timeline style={{ transition: "all .2s", }}>
        <TimelineItem>
          <TimelineOppositeContent fontSize={titleFontSize} color="text.secondary" sx={{ fontWeight: 'bold' }}>
            Data di Cambio Stato
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot variant="outlined" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent fontSize={titleFontSize} sx={{ fontWeight: 'bold' }}>Stato Bene</TimelineContent>
        </TimelineItem>
        {history.map(he =>
          <TimelineItem key={he.id}>
            <TimelineOppositeContent color="text.secondary">
              {displayFormattedWithTime(he.data)}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>{he.condizione.nome}</TimelineContent>
          </TimelineItem>
        )}
      </Timeline>
    </>
  )
}

export default BeneStateHistory
